// GET /api/progress 응답(functions/src/progress/service.ts, #96)
import type { VocabProgress } from './vocab-types';

export interface VocabCounts {
  total: number;
  byProgress: Record<VocabProgress, number>;
  defaultPublished: number;
  searchPublished: number;
}

export interface CategoryProgress {
  category: string;
  label: string;
  total: number;
  core: number;
  fringe: number;
  published: number;
  /** 기본 카드 목표(D-V11). 이전 API 응답에는 없다 */
  target?: number;
  /** 관리 중 기본 카드 후보 수 */
  defaultCandidates?: number;
  /** 현재 배포 릴리스의 앱 기본 카드 수(읽지 못하면 null) */
  appCards?: number | null;
}

export interface StageCount {
  stage: string;
  created: number;
  existing: number;
}

export interface ModelStats {
  modelId: string;
  label: string;
  generated: number;
  failed: number;
  costKrw: number;
  reviewed: number;
  approved: number;
  approvalRate: number | null;
  postprocessRequired: number;
  postprocessRate: number | null;
  published: number;
  costPerApprovedKrw: number | null;
}

export interface ProgressReport {
  generatedAt: string;
  /** byPurpose: 용도별(#98). 이전 API 응답에는 없다 */
  vocab: { all: VocabCounts; core: VocabCounts; fringe: VocabCounts; byPurpose?: { default_card: VocabCounts; search_only: VocabCounts }; categories: CategoryProgress[] };
  assets: { total: number; created: number; existing: number; byStage: StageCount[] };
  models: ModelStats[];
}

/** 자산 단계 표시(서버 STAGE_ORDER 순서로 온다) */
export const ASSET_STAGE_LABEL: Record<string, { label: string; color: string }> = {
  generating: { label: '생성 중', color: 'processing' },
  generation_failed: { label: '생성 실패', color: 'error' },
  postprocessing: { label: '후처리 중', color: 'processing' },
  postprocess_failed: { label: '후처리 실패', color: 'orange' },
  in_review: { label: '검수 대기', color: 'warning' },
  rework: { label: '재작업 대기', color: 'orange' },
  discarded: { label: '폐기', color: 'default' },
  approved: { label: '승인(게시 전)', color: 'blue' },
  publishing: { label: '게시 중', color: 'processing' },
  publish_failed: { label: '게시 실패', color: 'error' },
  published: { label: '게시 완료', color: 'success' },
};

export const percent = (r: number | null) => (r === null ? '-' : `${Math.round(r * 1000) / 10}%`);
